import styled from 'styled-components'

export const FieldWrapperUi = styled.div`
  position: relative;
`
